/// <reference path="../../components/commonClasses/common.interface.ts" />
/// <reference path="../../components/commonClasses/commonDataServiceBase.ts" />

module Meevo.Components.Common {
    export class AdpIntegrationService extends Meevo.Components.CommonClasses.CommonDataServiceBase implements Meevo.Components.CommonClasses.IADPIntegrationService {
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings, protected $http: angular.IHttpService) {
            super(appSettings, $http);
        }


        static factory(): Function {
            let svc = (appSettings: Meevo.Components.Common.IAppSettings, $http: angular.IHttpService) => {
                return new AdpIntegrationService(appSettings, $http);
            }

            svc.$inject = ["meevo.AppSettings", "$http"];
            return svc;
        }

        /**
           * Get settings
           * @returns {angular.IPromise} promise
           */
        getCompensationSettings(uri:string): angular.IPromise<Meevo.Model.CompensationSettings> {
            return this.customMethodData(`/api/${uri}`, 'GET', null).then((response) => {
                return response.data;
            });
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.adpIntegrationService", AdpIntegrationService.factory());
}